<template>
  <div class="relative">
    <main class="mt-10 md:mt-1 flex flex-col-reverse gap-8 items-center md:flex-row md:gap-16 md:justify-center min-h-[65vh] md:min-h-[80vh] relative z-10">
      <div class="space-y-4 text-center md:text-left px-8 md:px-10 z-10">
        <p class="text-amber-200/80 text-sm md:text-base tracking-wide fadein-up" style="animation-delay: 300ms">
          yo, i build cool apps 👋
        </p>
        <h1 class="text-5xl md:text-7xl font-extrabold gradient-text-white fadein-up leading-tight" style="animation-delay: 400ms">
          Aris Heryana
        </h1>
        <div class="py-1">
          <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full glass fadein-up" style="animation-delay: 500ms">
            <span class="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
            <h2 class="typewrite text-base md:text-lg font-medium text-amber-200" ref="typewriter">
              <span class="wrap">{{ txt }}</span>
            </h2>
          </div>
        </div>
        <p class="text-white/60 text-sm md:text-base fade-in-from-left max-w-md">
          Crafting apps that feel as good as they look ✨
        </p>
        <div class="flex gap-3 justify-center md:justify-start pt-2 fadein-up" style="animation-delay: 700ms">
          <router-link to="/about" class="px-6 py-2.5 rounded-full bg-gradient-to-r from-amber-400 to-orange-400 text-black font-semibold text-sm hover:shadow-lg hover:shadow-amber-500/25 transition-all duration-300 hover:scale-105">
            About Me
          </router-link>
          <router-link to="/portfolio" class="px-6 py-2.5 rounded-full glass glass-hover text-white font-medium text-sm transition-all duration-300 hover:scale-105">
            View Work →
          </router-link>
        </div>
      </div>
      <div class="flex justify-center md:justify-start fadein-right">
        <div class="relative">
          <div class="absolute -inset-1 rounded-full bg-gradient-to-r from-amber-400 via-orange-400 to-amber-400 glow-pulse"></div>
          <img alt="Aris Heryana - Mobile Developer" fetchpriority="high" width="180" height="180" decoding="async"
            class="relative w-[160px] h-[160px] md:w-[200px] md:h-[200px] rounded-full border-4 border-[#0a0a0a] object-cover"
            src="/img/avatar.png">
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      toRotate: ["Mobile Developer", "Flutter Dev", "Android Dev"],
      period: 2000,
      txt: '',
      loopNum: 0,
      isDeleting: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tick();
    });
  },
  beforeUnmount() {
    clearTimeout(this._tickTimeout);
  },
  methods: {
    tick() {
      let typewriter = this.$refs.typewriter;
      if (!typewriter) return;

      let i = this.loopNum % this.toRotate.length;
      let fullTxt = this.toRotate[i];

      this.txt = this.isDeleting
        ? fullTxt.substring(0, this.txt.length - 1)
        : fullTxt.substring(0, this.txt.length + 1);

      let delta = 200 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      this._tickTimeout = setTimeout(() => {
        this.tick();
      }, delta);
    },
  }
}
</script>

<style scoped>
.typewrite > .wrap {
  border-right: 0.08em solid rgba(255, 219, 112, 0.6);
}
</style>
